import React from 'react';

const DisAvatar = ({ 
  name = '', 
  size = 'md', 
  gender = 'neutral',
  onClick,
  className = '',
  colorIndex = 0
}) => {
  const sizes = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-12 h-12 text-base',
    lg: 'w-16 h-16 text-lg',
    xl: 'w-20 h-20 text-xl',
  };

  // Couleurs fun et variées pour chaque enfant
  const avatarColors = [
    'bg-gradient-to-br from-cyan-400 to-teal-500', // Cyan-Teal
    'bg-gradient-to-br from-blue-400 to-indigo-500', // Bleu
    'bg-gradient-to-br from-yellow-400 to-orange-500', // Jaune-Orange  
    'bg-gradient-to-br from-green-400 to-teal-500', // Vert
    'bg-gradient-to-br from-teal-400 to-emerald-500', // Teal-Emerald
    'bg-gradient-to-br from-indigo-400 to-blue-500', // Indigo-Bleu
    'bg-gradient-to-br from-orange-400 to-amber-500', // Orange-Amber
    'bg-gradient-to-br from-emerald-400 to-cyan-500', // Emerald-Cyan
  ];

  const genderColors = {
    girl: 'bg-gradient-to-br from-cyan-400 to-teal-500',
    boy: 'bg-gradient-to-br from-blue-400 to-indigo-500',
    neutral: avatarColors[colorIndex % avatarColors.length]
  };

  const initials = name
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);

  // Emojis basés sur le genre
  const genderEmoji = {
    girl: '👧',
    boy: '👦',
    neutral: '😊'
  };

  return (
    <div className="relative">
      <div
        className={`
          ${sizes[size]} ${genderColors[gender]} 
          rounded-full flex items-center justify-center font-bold text-white
          shadow-lg border-3 border-white
          ${onClick ? 'cursor-pointer hover:scale-110 transform transition-all duration-200 hover:shadow-xl' : ''}
          ${className}
        `}
        onClick={onClick}
      >
        {initials || '?'}
      </div>
      
      {/* Petit emoji décoratif */}
      <div className="absolute -top-1 -right-1 text-xs">
        {genderEmoji[gender]}
      </div>
    </div>
  );
};

export default DisAvatar;